import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ChoiceProcessModalComponent } from '../../presales-aftersales/choice-process-modal/choice-process-modal.component';

@Component({
  selector: 'app-help-anchor',
  templateUrl: './help-anchor.component.html',
  styleUrls: ['./help-anchor.component.scss'],
})
export class HelpAnchorComponent {
  @Input() list = [{ id: 0, name: '' }];

  activeId: string | null = null;
  flag = false;

  constructor(private router: Router, private dialog: MatDialog) {
    this.flag = this.router.url === '/helping';
    this.router.events.subscribe((r) => {
      this.flag = this.router.url === '/helping';
    });
  }

  onAnchorChange(id: string) {
    this.activeId = id;
  }

  showCustomerService() {
    this.dialog.open(ChoiceProcessModalComponent, {
      width: '471px',
    });
  }

  formatId(name: string) {
    return name
      .toLowerCase()
      .replace(/\s+/g, '-') // 空格 → -
      .replace(/&/g, 'and') // & → and
      .replace(/[^a-z0-9\u4e00-\u9fa5-]/g, ''); // 去掉非法字符
  }
}
